/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import { SkeletonRow } from 'src/components/ts-components/SkeletonBlock'

/** Eight indented rows, matching the tree's own rhythm. */
const TreeSkeleton = () => (
  <div css={wrapperStyle} data-testid='tree-skeleton'>
    {[0, 1, 1, 2, 2, 2, 1, 2].map((depth, index) => (
      <div key={index} style={{ paddingLeft: `${10 + depth * 16}px` }}>
        <SkeletonRow height={30} />
      </div>
    ))}
  </div>
)

const wrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
`

export default TreeSkeleton
